export { default } from './dist/vue-content-placeholders.common';
export * from './dist/vue-content-placeholders.common';
import './dist/vue-content-placeholders.css';